import { Box, Checkbox, FormControlLabel, FormGroup, LinearProgress, Tooltip, Typography } from '@mui/material';
import Warning from '@mui/icons-material/Warning';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import FiltrosAtivos from './FiltrosAtivos';

class OperacoesEmLoteSelecionarPartes extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            selecionarTodos: action,
            processosSelecionados: computed,
            processosSelecionaveis: computed,
            partesSelecionaveis: computed,
            todosSelecionados: computed,
            toggleSelecionarTodos: action
        });
    }

    componentDidMount() {
        this.store.resetCheckedOperacoesEmLotePartes();
    }

    componentWillUnmount() {
        this.store.resetCheckedOperacoesEmLotePartes();
    }

    selecionarTodos() {
        console.log('selecionarTodos');
        if (this.todosSelecionados) {
            this.store.resetCheckedOperacoesEmLotePartes();
        } else {
            this.store.checkAllOperacoesEmLotePartes(this.partesSelecionaveis);
        }
    }

    get processos() {
        return this.observableProps.processos || [];
    }

    get processosSelecionaveis() {
        return this.observableProps.processosSelecionaveis || [];
    }

    get partesSelecionaveis() {
        return this.observableProps.partesSelecionaveis || [];
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) =>
            this.store.isCheckedOperacoesEmLotePartes(registro.processo.numeroCompleto)
        );
    }

    get todosSelecionados() {
        for (const registro of this.processosSelecionaveis) {
            const numeroProcesso = registro.processo.numeroCompleto;
            const partes = this.partesSelecionaveis.get(numeroProcesso);
            for (const parte of partes) {
                if (!this.store.isCheckedOperacoesEmLotePartes(numeroProcesso, parte)) {
                    return false;
                }
            }
        }
        return true;
    }

    toggleSelecionarTodos = () => {
        this.selecionarTodos();
    };

    render() {
        if (this.sessaoStore.carregandoProcessos || this.store.carregandoProcessos) {
            return null;
        }

        return (
            <>
                {this.appStore.requisicoesPendentes && <LinearProgress color="secondary" />}
                <div style={{ margin: '8px 20px' }}>
                    <FiltrosAtivos />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>{this.renderInformacoesProcessos()}</div>
            </>
        );
    }

    renderInformacoesProcessos() {
        if (this.processosSelecionaveis.length > 0) {
            return <>{this.renderSelecionarTodos()}</>;
        }

        return (
            <Typography
                variant="subtitle1"
                style={{ fontWeight: 'bold', marginLeft: '25px' }}
            >
                {this.renderTotalizadores()}
            </Typography>
        );
    }

    renderSelecionarTodos() {
        return (
            <FormGroup>
                <FormControlLabel
                    style={{ margin: '0px 25px' }}
                    control={
                        <Checkbox
                            checked={this.todosSelecionados}
                            onChange={this.toggleSelecionarTodos}
                            disabled={this.observableProps.desabilitarBotaoSelecionarTodos}
                        />
                    }
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                            >
                                {'Selecionar todos (' + this.renderTotalizadores() + ')'}
                            </Typography>
                            {this.props.mensagemDesabilitacaoBotaoSelecionarTodos ? (
                                <Tooltip
                                    title={this.props.mensagemDesabilitacaoBotaoSelecionarTodos}
                                    sx={{ ml: 1 }}
                                >
                                    <Warning style={{ fill: 'darkorange' }} />
                                </Tooltip>
                            ) : null}
                        </Box>
                    }
                />
            </FormGroup>
        );
    }

    renderTotalizadores() {
        return (
            (this.salaSessaoStore.existeFiltroAtivo ? 'Filtrados: ' : 'Total: ') +
            this.processos.length +
            ' / selecionáveis: ' +
            this.processosSelecionaveis.length +
            ' / selecionados: ' +
            this.processosSelecionados.length
        );
    }
}

export default inject('stores')(observer(OperacoesEmLoteSelecionarPartes));
